<!-- 学校组织 -->
<template>
  <div class="overview">
    <!-- <p class="line"></p> -->
    <div class="content" v-html="data"></div>
  </div>
</template>

<script>
import { getSchoolOrganize } from "@/api/home";
export default {
  name: "overview",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      data: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    fetchData() {
      getSchoolOrganize().then((response) => {
        this.data = response.data.content;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="scss">
.content {
  img {
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
}
</style>
<style lang="scss" scoped>
.overview {
  padding-top: 45px;
  padding-bottom: 50px;
  .line {
    width: 45px;
    height: 3px;
    margin-bottom: 50px;
    background-color: transparent;
  }
}
</style>
